import Method from './method.js';
import Mode from './mode.js';
import { validateProp } from './ports.js';
import Response from './response.js';
import { isPlainObject, hasOwn, isEmptyObject } from './util.js';

const Core = (modules) => {
    let ProvidesObject = modules;
    let ResponseObject = {};

    for (let moduleName in ProvidesObject) {
        ResponseObject[moduleName] = {};
        for (let actionName in ProvidesObject[moduleName]) {
            let options = ProvidesObject[moduleName][actionName];
            ResponseObject[moduleName][actionName] = (config) => {
                let req = config || {};
                if (options['body']) {
                    req = extend(options['body'], config);
                }
                return Response(Object.assign({}, options, { 'body': req }));
            };
        }
    }

    return ResponseObject;
};

const extend = (propOptions, propsData) => {
    let value;
    let _propOptions;
    let isPropOptions;
    let target = {};

    if (propsData != null) {
        for (let key in propOptions) {
            value = propsData[key];
            _propOptions = propOptions[key] || {};
            isPropOptions = hasOwn(_propOptions, '$type') || hasOwn(_propOptions, '$default') || hasOwn(_propOptions, '$required') || hasOwn(_propOptions, '$validator');

            if (value && isPlainObject(value)) {
                if (!isPropOptions) {
                    target[key] = extend(_propOptions, value);
                }
            }

            if (!isEmptyObject(_propOptions) && !isPropOptions && !isPlainObject(value) && value !== undefined) {
                console.error(`错误提示：字段(${key})不正确，类型不匹配`);
                return {};
            }

            const propValue = validateProp(key, propOptions, propsData);

            if (propValue !== null && propValue.errorValid) {
                // console.log(propValue.desc[0])
                return {};
            }

            target[key] = propValue;
        }
    }

    return target;
};

export {
    Method,
    Mode,
    Core
};



// WEBPACK FOOTER //
// ./src/resource-api/core/index.js